import React from 'react';
import { View } from 'react-native';
import { useT } from '@transifex/react';

import { AuthLayout } from '../components/AuthLayout';
import { Logo } from '../components/Logo';
import ThemedText from '../components/ThemedText';

export default function MaintenanceScreen() {
  const t = useT();

  return (
    <AuthLayout>
      <View className='w-full items-center'>
        <Logo />

        <View className='w-full items-center px-5'>
          <ThemedText type='titleHero' className='mb-6'>
            🩺
          </ThemedText>

          <ThemedText type='titleHero' className='mb-6 text-center font-bold' style={{ fontSize: 40, lineHeight: 48 }}>
            {t("We'll be right back!")}
          </ThemedText>

          <ThemedText
            type='bodyRegular'
            color='dark'
            className='mb-5 text-center max-w-[500px]'
            style={{ fontSize: 18, lineHeight: 28 }}
          >
            {t("We're taking a quick break to make your Vida Health experience even better. Our team is working hard to get everything back up and running.")}
          </ThemedText>

          <ThemedText
            type='bodyRegular'
            color='subtle'
            className='mb-10 text-center max-w-[500px]'
          >
            {t("Thank you for your patience! Your health and wellness journey is important to us, and we'll be back to support you very soon.")}
          </ThemedText>
        </View>
      </View>
    </AuthLayout>
  );
}
